import { useEffect } from 'react';
import { getAppVersion } from '../config/app-version';

const LOCAL_STORAGE_VERSION_KEY = 'docs-app-version';

/**
 * Clears localStorage once per application version.
 * It compares the current app version with the stored one and, when they differ,
 * clears localStorage and stores the new version.
 */
export function useResetLocalStorageOnVersionChange(): void {
  useEffect(() => {
    if (typeof globalThis === 'undefined' || !globalThis.window?.localStorage) {
      return;
    }

    const currentVersion = getAppVersion();
    const storedVersion = globalThis.window.localStorage.getItem(LOCAL_STORAGE_VERSION_KEY);

    if (storedVersion === currentVersion) {
      return;
    }

    globalThis.window.localStorage.clear();
    globalThis.window.localStorage.setItem(LOCAL_STORAGE_VERSION_KEY, currentVersion);
  }, []);
}


